import { z } from 'zod';

export const StateWithContinuePath = z.object({
  continuePath: z
    .object({
      pathname: z.string().default('/'),
      search: z.string().default(''),
      hash: z.string().default(''),
    })
    .default({
      pathname: '/',
      search: '',
      hash: '',
    }),
});

export type StateWithContinuePath = z.infer<typeof StateWithContinuePath>;

export const getStateWithContinuePath = (
  state: unknown,
): StateWithContinuePath => {
  try {
    return StateWithContinuePath.parse(state);
  } catch (error) {
    return StateWithContinuePath.parse({});
  }
};
